import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { onSaveLimitDetails } from "../../Store/Slices/cardDataSlice";

const clientType = process.env.REACT_APP_CLIENT_TYPE;
const SECRET_KEY = process.env.REACT_APP_PRIVATE_KEY;
const ACCESS_KEY = process.env.REACT_APP_ENV_KEY;

const VTIGER_ENCRYPTION_KEY = "qGbJ7G7G87SBOrOXihegtXjQ";

const VTIGER_RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2K2OXmCc9hP4kioRqKKoQ5m+OZm4MmCzR3+tOUeJ3WtsPYfNGSEulfnNtXbJVtqZP8idT1egxBmpr+BI/j9itcE7NZqKvHWUCcAXv/d/fwo2M4YXXYQlJmda5y3PC69EI+rNDcElh+Lktpquq5bP3DffYKW76kH+LDgYDwNEtFTPk3uXftiYmF4j3PEDwb6TkPIHXIRQ9hx7T0br49AEVzUNKGCDyqJWo1VGvxbd5F7MH+3Gq+7vW+TaiCPiLhAjjS7GxTItmKXShHCtH8c55R34MPVQo69Ja+CVu1p/tyC/PRwRuC4CalyguUGsMbo53tpGyuHM9oqsW5edHVsbUwIDAQAB-----END PUBLIC KEY-----`;
const GetImageUrl = (imagePath) => {
  return `${process.env.REACT_APP_CLIENT_URL}${imagePath}`;
};
const ClientInfo = () => {
  return useSelector((state) => state.clientDataReducer);
};

const Dispatch = () => useDispatch();
const SupplierCapping = () => {
  return useSelector(
    (state) =>
      state.clientCappingReducer?.clientCappingData?.find(
        (findData) => findData?.enabled
      )?.upperCapping
  );
};

const MaxQuan = () => {
  return useSelector(
    (state) => state.clientDataReducer?.clientData?.overallCapping
  );
};

const fillTemplate = (template, values) => {
  return template.replace(/{{(.*?)}}/g, (_, key) => values[key.trim()] ?? "");
};

const showMaxMessg = (temp, maxQuantity, supCap, price) => {
  const values = { maxQuantity, price };
  const message = fillTemplate(temp, values);
  toast.error(message);
};

const ThemeData = () => {
  return useSelector((state) => state.themeSliceReducer?.getThemeData?.[0]);
};
const isValidColor = (value) => {
  const s = new Option().style;
  s.color = value;
  return s.color !== "";
};
function hexToRgbaGradient(hex) {
  if (!hex || typeof hex !== "string") return "";

  // expand shorthand hex (#abc => #aabbcc)
  if (hex.length === 4) {
    hex = "#" + [...hex.slice(1)].map((c) => c + c).join("");
  }

  const match = hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  if (!match) return "";

  const r = parseInt(match[1], 16);
  const g = parseInt(match[2], 16);
  const b = parseInt(match[3], 16);

  return `linear-gradient(to right, rgba(${r}, ${g}, ${b}, 1) 0%, rgba(${r}, ${g}, ${b}, 0.95) 50%, rgba(${r}, ${g}, ${b}, 0.8) 100%)`;
}

const ApplyThemeStyles = (themeData) => {
  const setStyle = (variable, color, fallback) => {
    const value =
      typeof color === "string" &&
        (color.startsWith("linear-gradient") || isValidColor(color))
        ? color
        : fallback;

    document.documentElement.style.setProperty(variable, value);
  };
  setStyle(
    "--card-heading-color",
    themeData?.primaryTextColorHeading,
    "#222222"
  );
  setStyle(
    "--shop-category-below-color",
    themeData?.secondaryTextColorHeading,
    "#515151"
  );
  setStyle(
    "--select-button-bg",
    themeData?.buttonWithBGSecondaryBgColor
      ? hexToRgbaGradient(themeData.buttonWithBGSecondaryBgColor)
      : "",
    "linear-gradient(to right, rgba(14, 77, 141, 1) 0%, rgba(14, 77, 141, 0.95) 50%, rgba(14, 77, 141, 0.8) 100%)"
  );

  setStyle(
    "--text-select-color",
    themeData?.buttonWithBGSecondaryTextColor,
    "#ffffff"
  );

  setStyle("--explore-back-coloer", themeData?.secondaryBgColor, "#20f2932");
  setStyle("--explore-back-coloer", themeData?.headerBorderColor, "#20f2932");
  setStyle("--explore-back-coloer", themeData?.bodyTextColor, "#20f2932");
  setStyle("--explore-back-coloer", themeData?.bodyBgColor, "#20f2932");
  setStyle(
    "--header-point-text-color1",
    themeData?.headerPointsTextColor,
    "#00477A"
  );
  setStyle("--header-point-bg", themeData?.headerPointsBgColor, "#eee");
  setStyle(
    "--username-text-color",
    themeData?.headerUserInitialsTextColor,
    "#565656"
  );
  setStyle("--initial-user-bg", themeData?.headerUserInitialsBgColor, "#eee");
  setStyle(
    "--header-point-star-color1",
    themeData?.pointsWithStarInBadgeTextColor,
    "#00477A"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.pointsWithStarInBadgeBgColor,
    "#20f2932"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.pointColorNotInBadge,
    "#20f2932"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.buttonWithBGPrimaryTextColor,
    "#20f2932"
  );
  setStyle(
    "--login-hover-text-color",
    themeData?.buttonWithBGPrimaryBorderColor,
    "#ffffff"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.buttonWithBGSecondaryTextColor,
    "#20f2932"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.buttonWithBGSecondaryBorderColor,
    "#20f2932"
  );

  setStyle(
    "--retrive-btn-back-color",
    themeData?.buttonWithBorderPrimaryTextColor,
    "#0e4d8d"
  );
  setStyle(
    "--retrive-btn-border-color",
    themeData?.buttonWithBorderPrimaryBorderColor,
    "#0e4d8d"
  );
  setStyle(
    "--retrieve-bg-color",
    themeData?.buttonWithBorderPrimaryBgColor,
    "#ffffff"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.buttonWithBorderPrimaryOnHover,
    "#20f2932"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.buttonWithBorderSecondaryTextColor,
    "#20f2932"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.buttonWithBorderSecondaryBorderColor,
    "#20f2932"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.buttonWithBorderSecondaryBgColor,
    "#20f2932"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.buttonWithBorderSecondaryOnHover,
    "#20f2932"
  );
  setStyle(
    "--trending-earn-upto-color",
    themeData?.textButtonWithBGPrimaryTextColor,
    "#787878"
  );
  setStyle(
    "--explore-back-coloer",
    themeData?.textButtonWithBGPrimaryOnHover,
    "#20f2932"
  );
  setStyle(
    "--login-button-color",
    themeData?.buttonWithBGPrimaryBgColor,
    "#0e4d8d"
  );
  setStyle(
    "--control-support",
    themeData?.textButtonWithBGSecondaryTextColor,
    "#0e4d8d"
  );
  setStyle(
    "--control-support-hov",
    themeData?.textButtonWithBGSecondaryOnHover,
    "#0e4d8d"
  );
  setStyle(
    "--cancel-button-text-color",
    themeData?.textButtonWithBGPrimaryBgColor,
    "#231f20"
  );
  setStyle(
    "--filter-checkbox-label-color",
    themeData?.formControlsTextColor,
    "#3a3a3a"
  );
  setStyle("--checkbox-color", themeData?.formControlsOnActionColor, "#0e4d8d");
  setStyle("--explore-back-coloer", themeData?.formControlsOnHover, "#20f2932");
  setStyle(
    "--card-starting-point-color",
    themeData?.giftCardStartingPriceTextColor,
    "linear-gradient(to right, #004d80, #007bb5)"
  );

  setStyle(
    "--card-earn-point-color",
    themeData?.giftCardEarnUpToPointTextColor,
    "linear-gradient(to right,#004d80,#007bb5)"
  );
  setStyle(
    "--denomination-price-color",
    themeData?.dinominationListTextColor,
    "#ffffff"
  );

  setStyle(
    "--explore-back-coloer",
    themeData?.dinominationBoxWithPriceImageUpload,
    "#20f2932"
  );
  setStyle(
    "--earn-points-text-color",
    themeData?.infoBadgePayWithPointsAndCashTextColor,
    "#222222"
  );
  setStyle(
    "--bg-white-2",
    themeData?.infoBadgePayWithPointsAndCashBGColor,
    "#F0ECEC"
  );
  setStyle(
    "--trending-earn-points-color",
    themeData?.buttonWithBGSecondaryOnHover,
    "#3a3a3a"
  );
  setStyle(
    "--footer-title-bg",
    themeData?.buttonWithBGPrimaryOnHover,
    "#1F222B"
  );
  /////////
  setStyle(
    "--explore-back-color",
    themeData?.promotionalStripBGColor,
    "#202932"
  );
  setStyle(
    "--explore-earn-text-color",
    themeData?.promotionalStripTextColor,
    "#ffffff"
  );
  setStyle(
    "--promotional-hover-text-color",
    themeData?.promotionalStripOnHover,
    "#fff"
  );
  setStyle("--bg-header", themeData?.headerBgColor, "#ffffff");
  setStyle(
    "--desktop-header-text-color",
    themeData?.headerTextColor,
    "#000000"
  );
  setStyle("--footer-bg-color", themeData?.footerBgColor, "#41444D");
  setStyle("--footer-text-color", themeData?.footerTextColor, "#ffffff");
  setStyle(
    "--login-text-color",
    themeData?.buttonWithBGPrimaryTextColor,
    "#ffffff"
  );
  setStyle(
    "--keep-bg-color",
    themeData?.thankYouCardKeepShoppingBGColor,
    "linear-gradient(86.41deg, #003B6B -26.81%, #0071B0 108.41%)"
  );
  setStyle(
    "--white-color-keep",
    themeData?.thankYouCardKeepShoppingTextColor,
    "#ffffff"
  );
  setStyle(
    "--thankyou-card-bg",
    themeData?.thankYouCardBackgroundColor,
    "#016DAB14"
  );
  setStyle("--getcode-text-color", themeData?.getCodeTextColor, "#ffffff");
  setStyle("--getcode-bg-color", themeData?.getCodeBgColor, "#0e4d8d");
  setStyle("--getcode-border-color", themeData?.getCodeBorderColor, "#0e4d8d");
  setStyle("--egiftcard-icon-color", themeData?.eGiftCardIconColor, "#016FD0");
  setStyle(
    "--disable-continue-color",
    themeData?.disabledContinueBtn,
    "#016DAB14"
  );
  setStyle("--show-more-bg-color", themeData?.moreGiftCardBgColor, "#ffffff");
  setStyle(
    "--redeemable-online-bg",
    themeData?.redeemableOnlineBgColor,
    " #F1FFEF"
  );
  setStyle(
    "--redeemable-offline-bg",
    themeData?.redeemableOfflineBgColor,
    "#E6F2FE"
  );
  setStyle(
    "--redeemable-both-bg",
    themeData?.redeemableOnlineOfflineBgColor,
    "#FBF7ED "
  );
  setStyle(
    "--redeemable-online-txt",
    themeData?.redeemableOnlineTxtColor,
    "#016FD0"
  );
  setStyle(
    "--redeemable-offline-txt",
    themeData?.redeemableOfflineTxtColor,
    "#037BF3"
  );
  setStyle(
    "--redeemable-both-txt",
    themeData?.redeemableOnlineOfflineTxtColor,
    "#C38C00"
  );
  setStyle("--active-dot-color", themeData?.bannerDotActiveColor, "#016FD0");
  // Generate dynamic SVG for slider and set as CSS var data URL
  const generateSliderSVG = (bgColor = "#8F9E5B", strokeColor = "#ffffff") => {
    const svgContent = `<svg width="57" height="36" viewBox="0 0 57 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.719897" y="0.676623" width="54.8325" height="34.6468" rx="17.3234" fill="${bgColor}"/>
<rect x="0.719897" y="0.676623" width="54.8325" height="34.6468" rx="17.3234" stroke="${bgColor}" stroke-width="1.35325"/>
<path d="M22.722 14.9546L22.722 21.7208" stroke="${strokeColor}" stroke-width="1.35325" stroke-linecap="round"/>
<path d="M28.1361 12.9253L28.1361 23.0747" stroke="${strokeColor}" stroke-width="1.35325" stroke-linecap="round"/>
<path d="M33.5502 14.9546L33.5502 21.7208" stroke="${strokeColor}" stroke-width="1.35325" stroke-linecap="round"/>
</svg>`;
    // Inline as data URL and assign to CSS var (works for pseudo elements)
    const encoded = encodeURIComponent(svgContent)
      .replace(/'/g, "%27")
      .replace(/\(/g, "%28")
      .replace(/\)/g, "%29");
    const dataUrl = `url("data:image/svg+xml,${encoded}")`;
    document.documentElement.style.setProperty("--slider-thumb-image", dataUrl);
  };

  // Call the function with your desired colors
  generateSliderSVG(themeData?.sliderBackgroundColor || "#8F9E5B", "#ffffff");

  // Setup dynamic range fill percentage and colors
  const setRangeFill = (input) => {
    if (!input) return;
    const min = Number(input.min || 0);
    const max = Number(input.max || 100);
    const val = Number(input.value || 0);
    const percent = ((val - min) * 100) / (max - min);
    input.style.setProperty("--slider-range-percent", `${percent}%`);
  };

  // Default fill and empty colors (theme-overridable)
  setStyle("--slider-range-fill", themeData?.sliderBackgroundColor, "#8F9E5B");
  setStyle("--slider-range-empty", themeData?.sliderDotLineColor, "#787878");

  // Attach listeners for all relevant range inputs
  const rangeInputs = document.querySelectorAll(
    '.filter-container input[type="range"], input[type="range"].rsBar'
  );
  rangeInputs.forEach((input) => {
    setRangeFill(input);
    input.addEventListener("input", () => setRangeFill(input));
    input.addEventListener("change", () => setRangeFill(input));
  });
  setStyle("--bg-voucher-2", themeData?.infoBadgeVoucherBGColor, "#F0ECEC");
  setStyle("--voucher-color", themeData?.infoBadgeVoucherTextColor, "#222222");
  setStyle(
    "--earn-text-color",
    themeData?.infoBadgePointsYouWillEarnTextColor,
    "#222222"
  );
  setStyle(
    "--light-blue-1",
    themeData?.infoBadgePointsYouWillEarnBGColor,
    "#D6E7F1"
  );
  setStyle("--redeem-text-color", themeData?.redeemText, "#0e4d8d");
  setStyle("--unlock-text-color", themeData?.unlockPointsTextColor, "#454545");
  setStyle("--light-grey-1", themeData?.unlockPointsBackgroundColor, "#E8EAEF");
  setStyle(
    "--denomination-box",
    themeData?.denominationBoxBackgroundColor,
    "#1B2A71"
  );
  setStyle(
    "--denomination-box-border",
    themeData?.denominationBoxBorderColor,
    "#016FD0"
  );
  setStyle("--denomination-earn-color", themeData?.earnPointColor, "#277D27");
  setStyle(
    "--plus-minus-bg",
    themeData?.plusMinusBackgroundColor,
    "rgba(236, 99, 43, 0.1)"
  );
  setStyle("--plus-minus-color", themeData?.plusMinusColor, "#EC632B");
  setStyle(
    "--giftcard-earpoint-color",
    themeData?.giftCardEarnPointColor,
    "#ffffff"
  );
  setStyle(
    "--giftcard-earpoint-bg",
    themeData?.giftCardEarnPointBackground,
    "#277D27"
  );
  setStyle("--giftcard-text-color", themeData?.giftCardTextColor, "#222222");
  setStyle("--light-green-bg", themeData?.giftCardBackgroundColor, "#016DAB14");
  setStyle("--gift-card-border", themeData?.giftCardBorderColor, "#E9E9E9");
  setStyle(
    "--product-info-color",
    themeData?.productInformationColor,
    "#212F52"
  );
  setStyle("--discount-bg-color", themeData?.discountBGColor, "#ffffffbf");
  setStyle(
    "--trending-border-color",
    themeData?.discountBorderColor,
    "#0000001a"
  );
  setStyle("--trending-off-color", themeData?.discountTextColor, "#fc511a");
  setStyle(
    "--term-condition-color",
    themeData?.termsConditionTextColor,
    "#787878"
  );
  setStyle(
    "--thank-paid-amount-bg",
    themeData?.thankyouCardBgColor,
    "#f5hyhf5f5"
  );
  setStyle(
    "--thank-page-amount-border",
    themeData?.thankyouCardBorderColor,
    "#d2dy2d280"
  );
  setStyle("--disable-button-color", themeData?.disableButtonText, "#ffffff");
  setStyle(
    "--disable-button-bg",
    themeData?.disableButtonBackground,
    "#016fd0"
  );
  setStyle(
    "--disable-btn-border-color",
    themeData?.disableButtonBorder,
    "#0e4d8d"
  );
};
const V3Data = () => {
  return useSelector((state) => state.cardDataSliceReducer);
};
const LoginV3Data = () => {
  return useSelector((state) => state.validateLoginTokenSliceReducer.data);
};

const LoginReducerData = (client) => {
  return useSelector((state) => state.loginAuthReducer?.data?.[0]);
};

const OrderData = () => {
  return useSelector((state) => state.orderReducer);
};

const ParseInt = (str) => {
  if (typeof str !== "string") return NaN;
  return Number(str.replace(/,/g, ""));
};
const GetCurrentDateTime = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() - 10);
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
const GenerateToken = () => {
  return useSelector((state) => state.generateTokenSliceReducer);
};
const EarnPoint = () => {
  return useSelector((state) => state.earnPointReducer);
};
const ApiRespCode = {
  v3Create: 200,
  success: 200,
  v3Success: "200",
  create: "201",
  update: "201",
  get: "200",
};
const VendorData = () => {
  return useSelector((state) => state.vendorOrderReducer);
};

const GetMemberData = () => {
  return useSelector((state) => state.getMemberSliceReducer);
};
const GetClientConfigData = () => {
  return useSelector((state) => state.clientConfigDataReducer);
};
const EmailData = () => {
  return useSelector((state) => state.sendMailReducer?.getMailData);
};
const SendSms = () => {
  return useSelector((state) => state.sendSmsReducer);
};
const SendMail = () => {
  return useSelector((state) => state.sendMailReducer);
};
const cleanHTML = (htmlString) => {
  return (
    htmlString && htmlString?.replace(/\s+/g, " ")?.replace(/"/g, "'")?.trim()
  );
};
const Navigate = () => useNavigate();
const CardDataSlice = () => {
  return useSelector((state) => state.cardDataSliceReducer);
};
const ClientConfigurationData = () => {
  return useSelector(
    (state) => state.clientConfigurationReducer.clientConfigurationData?.[0]
  );
};
const GetOrderCodeReducer = () => {
  return useSelector((state) => state.getOrderCodeReducer);
};
const RedeemPoint = () => {
  return useSelector((state) => state.redeemPointsReducer);
};
const UrlStoreReducer = () => {
  return useSelector((state) => state.urlStoreReducer);
};
const OnSwitchAccountSuccess = () => {
  return useSelector((state) => state.switchAccountReducer);
};
const TruncateName = (name, maxLength) => {
  if (!name || name.length <= maxLength) return name;

  const words = name.split(/[\s-]/);
  let result = "";

  for (let word of words) {
    if ((result + word).length <= maxLength) {
      result += (result ? " " : "") + word;
    } else {
      break;
    }
  }

  return result + "...";
};
const handleError = (text, duration = 5000) => {
  return toast.error(text, {
    autoClose: duration,
  });
};
const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    return e.preventDefault();
  }
};
// init
const gtag = (...args) => {
  window.dataLayer.push(args);
};

// flexible tracker
export const trackEvent = (eventName, payload = {}) => {
  const data = {
    event: eventName,
    ...payload,
  };

  window.dataLayer = window.dataLayer || [];
  try {
    window.dataLayer.push({ items: null });
  } catch (e) {
    /* ignore */
  }
  window.dataLayer.push(data);
};

export const formatPrice = (amount) => {
  const num = parseFloat(amount);
  return Number.isInteger(num)
    ? parseInt(num)
    : num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
};
const GetProdBudSumData = () => {
  return useSelector((state) => state.customerProductReducer);
};

function getWeekOfMonth(date) {
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const firstDayWeekday = (firstDay.getDay() + 6) % 7; // Monday = 0
  const adjustedDate = date.getDate() + firstDayWeekday;
  return Math.ceil(adjustedDate / 7);
}

function filterCurrentPeriodData(data) {
  const today = new Date();

  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();

  const dailyIdentifier = `${dd}${mm}${yyyy}`;
  const monthlyIdentifier = `${mm}${yyyy}`;
  const weekOfMonth = getWeekOfMonth(today);
  const weeklyIdentifier = `W${weekOfMonth}_${mm}${yyyy}`;

  return data.filter(
    (item) =>
      item.purchaseLimitIdentifier === dailyIdentifier ||
      item.purchaseLimitIdentifier === weeklyIdentifier ||
      item.purchaseLimitIdentifier === monthlyIdentifier
  );
}

const handleLimit = (payload, prodSumData, call, translation, limits) => {
  if (sessionStorage.getItem("login")) {
    const amount = Number(payload);

    // Merge prodSumData (used limits) with limits (allowed limits)
    const mergedData = limits?.map((limit) => {
      const used =
        Array.isArray(prodSumData) &&
        prodSumData?.find((p) => p.limitType === limit.limitType);
      return {
        limitType: limit.limitType,
        limitValue: Number(limit.limitValue),
        totalPurchasedValue: Number(used?.totalPurchasedValue || 0),
      };
    });

    const limitTypes = ["Daily", "Weekly", "Monthly", "Quarterly"];
    let limitBreached = null;

    for (const type of limitTypes) {
      const current = mergedData?.find((l) => l.limitType === type);
      if (!current) continue;

      const { limitValue, totalPurchasedValue } = current;
      const available = limitValue - totalPurchasedValue;

      // check if user exceeded this limit or available is 0
      if (amount > available || available === 0) {
        let reset_text = "";
        switch (type) {
          case "Daily":
            reset_text = translation?.next_day;
            break;
          case "Weekly":
            reset_text = translation?.next_week;
            break;
          case "Monthly":
            reset_text = translation?.next_month;
            break;
          case "Quarterly":
            reset_text = translation?.next_quarter;
            break;
          default:
            reset_text = "";
        }

        limitBreached = {
          amount: limitValue,
          timePeriod: type,
          disable: true,
          reset_text,
        };
        break;
      }
    }

    // If user exceeds any limit → disable and show info
    if (limitBreached) {
      call(onSaveLimitDetails(limitBreached));
    } else {
      // If user reduces amount within range → reset warning
      call(
        onSaveLimitDetails({
          amount: null,
          timePeriod: null,
          disable: false,
          reset_text: "",
        })
      );
    }
  } else {
    call(
      onSaveLimitDetails({
        amount: null,
        timePeriod: null,
        disable: false,
        reset_text: "",
      })
    );
  }
};

const getImageUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http")
    ? url
    : `${process.env.REACT_APP_CLIENT_URL}${url}`;
};

const dynamicSuccessEmailColumnChnages = (emailTemplate, cardNumber, cardPin) => {
  let htmlStringData = emailTemplate;
  if (cardNumber && cardPin) {
    htmlStringData = htmlStringData?.replace(/{{#noGcId}}[\s\S]*?{{\/noGcId}}/, "");
    htmlStringData = htmlStringData?.replace(/{{#noVoucherCode}}[\s\S]*?{{\/noVoucherCode}}/, "");
    htmlStringData = htmlStringData
      ?.replace("{{#noGcId}}", "")
      ?.replace("{{/noGcId}}", "");
    htmlStringData = htmlStringData
      ?.replace("{{#noVoucherCode}}", "")
      ?.replace("{{/noVoucherCode}}", "");
    htmlStringData = htmlStringData
      ?.replace("{{#noFourCol}}", "")
      ?.replace("{{/noFourCol}}", "");
  }

  else if (!cardNumber) {
    htmlStringData = htmlStringData?.replace(/{{#noFourCol}}[\s\S]*?{{\/noFourCol}}/, "");
    htmlStringData = htmlStringData?.replace(/{{#noVoucherCode}}[\s\S]*?{{\/noVoucherCode}}/, "");
    htmlStringData = htmlStringData
      ?.replace("{{#noGcId}}", "")
      ?.replace("{{/noGcId}}", "");
  }
  else if (!cardPin) {
    htmlStringData = htmlStringData?.replace(/{{#noFourCol}}[\s\S]*?{{\/noFourCol}}/, "");
    htmlStringData = htmlStringData?.replace(/{{#noGcId}}[\s\S]*?{{\/noGcId}}/, "");
    htmlStringData = htmlStringData
      ?.replace("{{#noVoucherCode}}", "")
      ?.replace("{{/noVoucherCode}}", "");
  }
  return htmlStringData;
}

const getConfigValue = (configurations, key) => {
  const value = configurations?.find((item) => item.configKey === key)?.configValue;
  return value ? JSON.parse(value) : "";
};

export {
  clientType,
  ACCESS_KEY,
  SECRET_KEY,
  GetImageUrl,
  MaxQuan,
  ClientInfo,
  ThemeData,
  ApplyThemeStyles,
  showMaxMessg,
  SupplierCapping,
  Dispatch,
  V3Data,
  LoginV3Data,
  OrderData,
  ParseInt,
  GetCurrentDateTime,
  GenerateToken,
  EarnPoint,
  ApiRespCode,
  VendorData,
  GetMemberData,
  GetClientConfigData,
  CardDataSlice,
  EmailData,
  SendSms,
  SendMail,
  Navigate,
  ClientConfigurationData,
  TruncateName,
  RedeemPoint,
  UrlStoreReducer,
  GetOrderCodeReducer,
  handleError,
  cleanHTML,
  LoginReducerData,
  handleKeyDown,
  VTIGER_ENCRYPTION_KEY,
  VTIGER_RSA_PUBLIC_KEY,
  gtag,
  GetProdBudSumData,
  handleLimit,
  OnSwitchAccountSuccess,
  getImageUrl,
  dynamicSuccessEmailColumnChnages,
  getConfigValue
};
